import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import ByLogger from '@bfe/by-logger';
import ByObserver from './byObserver';

var LoggerObserver = /*#__PURE__*/function (_ByObserver) {
  _inherits(LoggerObserver, _ByObserver);

  var _super = _createSuper(LoggerObserver);

  function LoggerObserver(logOpts, logEventOpts) {
    var _this;

    _classCallCheck(this, LoggerObserver);

    _this = _super.call(this);

    if (!logOpts || !logEventOpts) {
      throw new Error('缺少初始化配置参数');
    }

    _this.logger = new ByLogger(logOpts, logEventOpts);

    _this.logger.init();

    return _this;
  }

  _createClass(LoggerObserver, [{
    key: "update",
    value: function update() {
      var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.logger.log(args);
    }
  }]);

  return LoggerObserver;
}(ByObserver);

export { LoggerObserver as default };